module.exports = "/assets/data/972d565cbf2be35924d8aa1c6f083ac3-CO6.data.json";